import admin from './admin';
import auth from './auth';
import other from './other';

export default {
  ...admin,
  ...auth,
  ...other,
};
